import { c as _c } from "react/compiler-runtime";
import { CityDataType } from "@website/accommodation-ui/hotel-search";
import { VillaSearchPropertiesType, VillaSearchTextItemType } from "@website/accommodation-ui/villa-search";
import { DatepickerSelectedDateType } from "@website/ui/datepicker";
import { dateFormat } from "@website/utils/date-format";
import { INITIAL_ITEMS as HOMEPAGE_VILLA_SUGGESTIONS } from "@website/website-ui/search-villa/search-villa-constants";
import get from "lodash-es/get";
import toNumber from "lodash-es/toNumber";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { ParsedUrlQueryInput } from "node:querystring";
import { useState } from "react";
import { fetchSearchTextData } from "./index.server";
import { handleSearchInitiated } from "./index.tracking";
const getDestinationSlug = (destination: unknown) => {
  const [pathname] = toString(destination).split(/[?#]/);
  return pathname.split("/").filter(Boolean).at(-1) || "";
};
const searchAutocompleteFetcher = (text: string) => text.length > 1 && fetchSearchTextData(text);
const searchSuggestion: Array<VillaSearchTextItemType> = HOMEPAGE_VILLA_SUGGESTIONS.map(item => {
  const id = String(item.value);
  return {
    id,
    title: item.label,
    url: item.slug || "",
    hotel_count: 0,
    info: "",
    isHotel: false,
    subtitle: item.entity || "",
    type: item.entity?.toLowerCase()
  };
});
export const useVillaSearch = t0 => {
  const $ = _c(66);
  const {
    locationData,
    seoPageTitle
  } = t0;
  const router = useRouter();
  const {
    date_to,
    date_from,
    room_count,
    room_capacity,
    version
  } = router.query as Record<string, string>;
  const [isSearchPanelOpen, setIsSearchPanelOpen] = useState(false);
  let t1;
  if ($[0] !== date_from || $[1] !== router.locale) {
    t1 = dateFormat(date_from, {
      locale: router.locale,
      numberConvert: false,
      template: "yyyy"
    });
    $[0] = date_from;
    $[1] = router.locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = Number(t1);
  let t3;
  if ($[3] !== date_from || $[4] !== router.locale) {
    t3 = dateFormat(date_from, {
      locale: router.locale,
      numberConvert: false,
      template: "MM"
    });
    $[3] = date_from;
    $[4] = router.locale;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = Number(t3);
  let t5;
  if ($[6] !== date_from || $[7] !== router.locale) {
    t5 = dateFormat(date_from, {
      locale: router.locale,
      numberConvert: false,
      template: "dd"
    });
    $[6] = date_from;
    $[7] = router.locale;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = Number(t5);
  let t7;
  if ($[9] !== date_from) {
    t7 = toString(dateFormat(date_from, {
      locale: "en",
      template: "yyyy-MM-dd"
    }));
    $[9] = date_from;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t2 || $[12] !== t4 || $[13] !== t6 || $[14] !== t7) {
    t8 = {
      year: t2,
      month: t4,
      day: t6,
      dateTime: t7
    };
    $[11] = t2;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== date_to || $[17] !== router.locale) {
    t9 = dateFormat(date_to, {
      locale: router.locale,
      numberConvert: false,
      template: "yyyy"
    });
    $[16] = date_to;
    $[17] = router.locale;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = Number(t9);
  let t11;
  if ($[19] !== date_to || $[20] !== router.locale) {
    t11 = dateFormat(date_to, {
      locale: router.locale,
      numberConvert: false,
      template: "MM"
    });
    $[19] = date_to;
    $[20] = router.locale;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = Number(t11);
  let t13;
  if ($[22] !== date_to || $[23] !== router.locale) {
    t13 = dateFormat(date_to, {
      locale: router.locale,
      numberConvert: false,
      template: "dd"
    });
    $[22] = date_to;
    $[23] = router.locale;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = Number(t13);
  let t15;
  if ($[25] !== date_to) {
    t15 = toString(dateFormat(date_to, {
      locale: "en",
      template: "yyyy-MM-dd"
    }));
    $[25] = date_to;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t10 || $[28] !== t12 || $[29] !== t14 || $[30] !== t15) {
    t16 = {
      year: t10,
      month: t12,
      day: t14,
      dateTime: t15
    };
    $[27] = t10;
    $[28] = t12;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t16 || $[33] !== t8) {
    t17 = [t8, t16];
    $[32] = t16;
    $[33] = t8;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  const datePickerInitialValues = t17;
  const t18 = toNumber(room_capacity) > 0 ? room_capacity : 0;
  let t19;
  if ($[35] !== t18) {
    t19 = toNumber(t18);
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== room_count) {
    t20 = toNumber(room_count);
    $[37] = room_count;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t19 || $[40] !== t20) {
    t21 = {
      child: 0,
      adult: t19,
      room: t20
    };
    $[39] = t19;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  const passengerCountInitialValues = t21;
  let t22;
  if ($[42] !== router || $[43] !== version) {
    t22 = (cityTitle, date_from_0, date_to_0, adults, children, noRooms, type, destinationId, destinationTitle) => {
      handleSearchInitiated({
        date_from: date_from_0,
        date_to: date_to_0,
        region_id: toString(destinationId),
        region: destinationTitle
      });
      const _locationType = type || get(router.query, "locationType");
      const _cityTitle = getDestinationSlug(cityTitle || get(router.query, "cityTitle"));
      return router.replace({
        pathname: "/[locationType]/[cityTitle]",
        query: {
          room_count: noRooms,
          date_from: date_from_0,
          date_to: date_to_0,
          version: version || "room",
          cityTitle: _cityTitle,
          locationType: _locationType,
          ...(toNumber(adults) > 0 ? {
            room_capacity: adults
          } : {})
        } as ParsedUrlQueryInput
      }, undefined, {
        shallow: router.query.locationType === _locationType && router.query.cityTitle === _cityTitle,
        scroll: false
      }).finally(() => setIsSearchPanelOpen(false));
    };
    $[42] = router;
    $[43] = version;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  const handleSearchSubmit = t22;
  let t23;
  if ($[45] !== locationData?.title || $[46] !== locationData?.type) {
    t23 = () => {
      if (locationData?.type === "state") {
        return `استان ${locationData?.title}`;
      }
      return locationData?.title;
    };
    $[45] = locationData?.title;
    $[46] = locationData?.type;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  const getCityTitle = t23;
  let t24;
  if ($[48] !== getCityTitle) {
    t24 = getCityTitle();
    $[48] = getCityTitle;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  const t25 = Number(room_capacity) === 0 ? undefined : room_capacity;
  let t26;
  if ($[50] !== date_from || $[51] !== date_to || $[52] !== seoPageTitle || $[53] !== t24 || $[54] !== t25) {
    t26 = {
      cityTitle: t24,
      seoPageTitle,
      dateFrom: date_from,
      dateTo: date_to,
      adults: t25,
      children: "",
      noRooms: ""
    };
    $[50] = date_from;
    $[51] = date_to;
    $[52] = seoPageTitle;
    $[53] = t24;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = setIsSearchPanelOpen.bind(null, false);
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== datePickerInitialValues || $[58] !== handleSearchSubmit || $[59] !== locationData || $[60] !== passengerCountInitialValues) {
    t28 = {
      initialCityData: locationData,
      passengerCountInitialValues,
      datePickerInitialValues,
      onClose: t27,
      handleSearchSubmit,
      searchAutocompleteFetcher,
      searchSuggestion
    };
    $[57] = datePickerInitialValues;
    $[58] = handleSearchSubmit;
    $[59] = locationData;
    $[60] = passengerCountInitialValues;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== isSearchPanelOpen || $[63] !== t26 || $[64] !== t28) {
    t29 = {
      isSearchPanelOpen,
      setIsSearchPanelOpen,
      searchSummaryProperties: t26,
      searchPanelProperties: t28
    };
    $[62] = isSearchPanelOpen;
    $[63] = t26;
    $[64] = t28;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  return t29 as VillaSearchPropertiesType;
};